// 活动ID
export const activityId = 10152;
// 是否是 TOKI APP
export const isToki = /Toki/ig.test(navigator.userAgent);


// none(-1, "未知"),
// score(-2, "分数"),
// civilians(0, "贵族-0"),
// knight(1, "贵族-1"),
// viscount(2, "贵族-2"),
// count(3, "贵族-3"),
// marquis(4, "贵族-4"),
// duke(5, "贵族-5"),
// king(6, "贵族-6"),
// avatars(20, "麦圈"),
// vip(21, "vip"),
// entrance(22, "进场特效"),
// coin(23, "金币"),
// diamond(24, "钻石"),
// driver_seat(26, "座驾"),
// barrage(27, "弹幕"),
// gift(28, "背包"),
// medal(29, "勋章"),
// tag(30, "标签"), // 称号
// recommend_top(31, "推荐置顶"),
// bubble(32, "气泡"),
// mini_profile_card(33, "迷你资料卡"),
// room_background(34, "房间背景"),
// room_level_experience(35, "增加房间等级经验"),
// user_charm_level_experience(36, "增加用户魅力等级经验"),
// vip_experience_card(37, "vip经验翻倍卡"),
// user_wealth_level_exp(38, "增加财富等级经验"),
// 奖励类型名称 奖励类型-文案编号
export const rewardTypeName = {
    '20': 10,//麦圈
    // '32': 97,//气泡
    '29': 12,//勋章
    '26': 11,//座驾
    // '34': 92,//房间背景
    // '28': 98,//背包
    // '30': 96,//称号
    '24': 4,//钻石
    '23': 5,//金币
    '20001624': 85,//24年度-盛典水晶
    '20001625': 86,//24年度-中级权杖
    '20001626': 87,//24年度-高级
    '20001628': 88,//24年度-稀有
    '20001634': 89,//24年度-水晶之星
    "-1":  95,    // iPhone 16 promax
    "-2":  96,    // Sony WH-1000XM5
    "-3":  97,    // airpod 4
    "-4":  98,    // 定制靓号EG
    "-5":  99,    // Tesla Model Y
    "-6":  100,    // LV Handbag ON THE GO
    "-7":  101,    // iPhone 16 Pro Max  256GB
    "-8":  102,    // Dyson 扫地机器人
    "-9":  98,      // 定制靓号IN,US
    "-10": 104,    // 定制礼物IN,US
    "-11": 105,    // 金币
    "-12": 106,    // top1直通IN,US
    "-13": 107,    // Honda WR-V
    "-14": 108,    // SAMSUNG BUNDLE
    "-15": 109,    // Iklan Eksklusif
    "-16": 110,    // 奖杯
    "-17": 119,    // 線下盛典席位
    "-18": 120,    // 金條
    "-19": 123,    // iPhone 16 Pro Max  512GB
    "-20": 124,    // iPad Air  รุ่น 11 นิ้ว  256GB  Wi-Fi
    "-21": 125,    // LV กระเป๋าสตางค์รุ่น Emilie
    "-22": 126,    // CHANEL น้ำหอม N°5 CASE
    "-23": 135,    // Fine Gold 999.9
    "-24": 136,    // Apple AirPods 4
    "-25": 127,    // 2024 11インチiPad Pro（スペースブラック）
    "-26": 128,    // Aladdin X2 Plus（ピクセラ Xit AirBox付き）
    "-27": 129,    // 高島屋ローズセレクションThe　BEST　GIFT　WXコース
    "-28": 130,    // Nintendo Switch(有機ELモデル)
    "-29": 139,    // iPhone 16 256GB
    "-30": 140,    // iPad 10th 64G
    "-31": 141,    // Apple AirPods 4
}

export interface UserType {
    isGifter: boolean,
    country: string,
    gender: number,
    avatar: string,
    goldenId: string,
    userId: string,
    platform: number,
    isSign: boolean,
    uid: number,
    createTime: number,
    grade: number,
    name: string,
    flagFid: string
    giftCount: number,
    liveStatus: number,
    roomInfo?: any,
    area: string,
    flag: string,
}

export interface UserInfoType {
    subScore: number,
    display: boolean,
    rank: number | string,
    score: number,
    scoreGap?: number,
    userInfo: UserType,
    inStamp: boolean,
}


export interface RewardType {
    uid: number,
    area: string,
    activityId: number,
    reason: number,
    gender: number,
    grade: number,
    index: number,
    stage: number,
    goodId: number,
    type: number,
    count: number,
    duration: number,
    image: string,
    webp: number,
    mp4: number,
    key: number,
    addScore: number,
    scoreRate: number,
    chatType: number,
    price: number,
    saveFlag: boolean,
    beforeSingle: boolean,
    rewardType: number,
    groupNumber?: number,
}

export interface StageInfoType {
    stage: number, //第几天
    step: number,
    isInHalloween: boolean, //是否在万圣节当天
}

export interface MonsterInfoType {
    curLevel: number, //用户当前等级
    leftPumpkinCount: number, //剩余的南瓜钥匙
    monsterLevel: number, //选择的怪兽等级
    fullBlood: number, //满血血量
    rewardList: RewardType[],
    leftBlood: number, //剩余血量
    timeLeft: number,
    status: number, //状态
}

export interface CandyInfoType {
    rewardList: RewardType[],
    totalLotteryCount: number,
    candyInfoList: { count: number, type: number, id: number }[],
    leftLotteryCount: number,
    timeLeft: number,
    status: number,
}

export interface TaskInfoType {
    rewardKey: number, //奖励的南瓜数
    taskCount: number, //完成任务次数
    dayLimit: number, //每天限制 -1:无限制
    needScore: number, //完成一次需要的分数
    allLimit: number, //活动全程限制 -1:无限制
    index: number,
    taskNum: number //当前任务的完成分数
}
